(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("immutable"));
	else if(typeof define === 'function' && define.amd)
		define("DecapCmsLibWidgets", ["immutable"], factory);
	else if(typeof exports === 'object')
		exports["DecapCmsLibWidgets"] = factory(require("immutable"));
	else
		root["DecapCmsLibWidgets"] = factory(root["DecapCmsDefaultExports"]["Immutable"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__2522__) => {
return 